import React, { useCallback, useEffect, useState } from "react";
import { Button, MessageBanner, Modal, ModalFooter, TextArea, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
export var BulkStartInvestigationDialog = function (_a) {
    var open = _a.open, selectedCount = _a.selectedCount, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useState(""), noteText = _c[0], setNoteText = _c[1];
    useEffect(function () {
        if (!open)
            setNoteText("");
    }, [open]);
    var handleClose = useCallback(function () {
        setNoteText("");
        onClose();
    }, [onClose]);
    var handleSubmit = useCallback(function () {
        onSubmit(noteText.trim());
    }, [noteText, onSubmit]);
    var isValid = noteText.trim().length > 0 && selectedCount > 0;
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.bulk.takeOver.title",
        }), onClose: handleClose, size: "small", footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: handleClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.takeOver.summary", values: { count: selectedCount } })),
        React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.investigation.note.label",
            }), value: noteText, onChange: function (e) {
                return setNoteText(e.target.value);
            }, required: true })));
};
